// ErrorBoundary.jsx
import React from 'react';

import application from 'application';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    application.constructor.logError('UNHANDLED_ERROR', {
      error,
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    const errorMessage = this.state.error?.message || '';
    if (this.state.hasError) {
      console.error(this.state);
      if (errorMessage.indexOf('Failed to fetch dynamically imported module') !== -1) {
        return window.location.reload();
      }
      if (errorMessage.indexOf('Unable to preload CSS') !== -1) {
        return window.location.reload();
      }
      return <div style={{ padding: 20, color: 'red' }}>Something went wrong.</div>;
    }
    return this.props.children;
  }
}